export default {
  path: '',
  name: 'home',
  component: () => import('../views/home/Home.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'home',
      linkText: 'Общая информация'
    }
  }
}